export {
  GetLanguageNameFromCode,
}

function GetLanguageNameFromCode(languageCode) {
  const languageMap = {
    'de-CH': 'Deutsch',
    'fr-CH': 'Französisch',
    'it-CH': 'Italienisch',
  };

  if (languageMap[languageCode]) {
    return languageMap[languageCode];
  }
}